import * as types from "./types";
import { ErrorModel } from "./model";

export default function ErrorReducer(state: any = ErrorModel, action) {
  switch (action.type) {
    case types.SET_ERROR:
      return {
        ...state,
        errorCode: action.payload.error.code,
        errorMessage: action.payload.error.message,
        where: action.payload.where,
      };

    case types.RESET_ERROR_VALUES:
      return {
        ...state,
        errorCode: action.payload.error.code,
        errorMessage: action.payload.error.message,
        where: action.payload.where,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/ErrorManage/reducer.js